/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from "@tanstack/react-query";

import { useCallback } from "react";

import type {
    ApiMultipleResult,
    ApiResult,
    DeviceGroupDailyUptimesParams,
    DeviceGroupDeleteParams,
    DeviceGroupDto,
    DeviceGroupMapDevicesRequest,
    DeviceGroupMapRfidTagsRequest,
    DeviceGroupMapUserAccountsRequest,
    DeviceGroupUptimeParams,
    DeviceGroupUptimeResponse,
    ToggleFavouriteDeviceGroupParams,
    UpdateDeviceGroupContactsRequest,
} from "./query.schemas";

import { useCustomFetchClient } from "./mutator/custom-fetch";
import type { ErrorType, BodyType } from "./mutator/custom-fetch";

/**
 * An OData endpoint that lists device groups visible for the current IlluminateUser. Pass an 'orgSearch' OData filter parameter to search organisation device groups by organisation name/id, also returning the children of any matched organisation; eg $filter=contains(tolower(orgSearch),'acme').
 */
export const useDeviceGroupsODataHook = () => {
    const deviceGroupsOData = useCustomFetchClient<DeviceGroupDto[]>();

    return useCallback(
        (signal?: AbortSignal) => {
            return deviceGroupsOData({
                url: `/device-groups-odata`,
                method: "GET",
                signal,
            });
        },
        [deviceGroupsOData],
    );
};

export const getDeviceGroupsODataQueryKey = () => {
    return [`/device-groups-odata`] as const;
};

export const useDeviceGroupsODataQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceGroupsODataHook>>>,
    TError = ErrorType<unknown>,
>(options?: {
    query?: Partial<
        UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useDeviceGroupsODataHook>>>,
            TError,
            TData
        >
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getDeviceGroupsODataQueryKey();

    const deviceGroupsOData = useDeviceGroupsODataHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useDeviceGroupsODataHook>>>
    > = ({ signal }) => deviceGroupsOData(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDeviceGroupsODataHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DeviceGroupsODataQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeviceGroupsODataHook>>>
>;
export type DeviceGroupsODataQueryError = ErrorType<unknown>;

export function useDeviceGroupsOData<
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceGroupsODataHook>>>,
    TError = ErrorType<unknown>,
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useDeviceGroupsODataHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<ReturnType<typeof useDeviceGroupsODataHook>>
                    >,
                    TError,
                    Awaited<
                        ReturnType<ReturnType<typeof useDeviceGroupsODataHook>>
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDeviceGroupsOData<
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceGroupsODataHook>>>,
    TError = ErrorType<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useDeviceGroupsODataHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<ReturnType<typeof useDeviceGroupsODataHook>>
                    >,
                    TError,
                    Awaited<
                        ReturnType<ReturnType<typeof useDeviceGroupsODataHook>>
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDeviceGroupsOData<
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceGroupsODataHook>>>,
    TError = ErrorType<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useDeviceGroupsODataHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useDeviceGroupsOData<
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceGroupsODataHook>>>,
    TError = ErrorType<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useDeviceGroupsODataHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useDeviceGroupsODataQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Device group details
 */
export const useDeviceGroupDetailHook = () => {
    const deviceGroupDetail = useCustomFetchClient<DeviceGroupDto>();

    return useCallback(
        (deviceGroupTag: string, signal?: AbortSignal) => {
            return deviceGroupDetail({
                url: `/device-groups/${deviceGroupTag}`,
                method: "GET",
                signal,
            });
        },
        [deviceGroupDetail],
    );
};

export const getDeviceGroupDetailQueryKey = (deviceGroupTag: string) => {
    return [`/device-groups/${deviceGroupTag}`] as const;
};

export const useDeviceGroupDetailQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceGroupDetailHook>>>,
    TError = ErrorType<unknown>,
>(
    deviceGroupTag: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useDeviceGroupDetailHook>>
                >,
                TError,
                TData
            >
        >;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getDeviceGroupDetailQueryKey(deviceGroupTag);

    const deviceGroupDetail = useDeviceGroupDetailHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useDeviceGroupDetailHook>>>
    > = ({ signal }) => deviceGroupDetail(deviceGroupTag, signal);

    return {
        queryKey,
        queryFn,
        enabled: !!deviceGroupTag,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDeviceGroupDetailHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DeviceGroupDetailQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeviceGroupDetailHook>>>
>;
export type DeviceGroupDetailQueryError = ErrorType<unknown>;

export function useDeviceGroupDetail<
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceGroupDetailHook>>>,
    TError = ErrorType<unknown>,
>(
    deviceGroupTag: string,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useDeviceGroupDetailHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<ReturnType<typeof useDeviceGroupDetailHook>>
                    >,
                    TError,
                    Awaited<
                        ReturnType<ReturnType<typeof useDeviceGroupDetailHook>>
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDeviceGroupDetail<
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceGroupDetailHook>>>,
    TError = ErrorType<unknown>,
>(
    deviceGroupTag: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useDeviceGroupDetailHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<ReturnType<typeof useDeviceGroupDetailHook>>
                    >,
                    TError,
                    Awaited<
                        ReturnType<ReturnType<typeof useDeviceGroupDetailHook>>
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDeviceGroupDetail<
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceGroupDetailHook>>>,
    TError = ErrorType<unknown>,
>(
    deviceGroupTag: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useDeviceGroupDetailHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useDeviceGroupDetail<
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceGroupDetailHook>>>,
    TError = ErrorType<unknown>,
>(
    deviceGroupTag: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useDeviceGroupDetailHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useDeviceGroupDetailQueryOptions(
        deviceGroupTag,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Delete device group. Group must have no devices, rfid tags, or user accounts assigned before it can be deleted.
 */
export const useDeviceGroupDeleteHook = () => {
    const deviceGroupDelete = useCustomFetchClient<ApiMultipleResult>();

    return useCallback(
        (
            deviceGroupTag: string,
            params?: DeviceGroupDeleteParams,
            signal?: AbortSignal,
        ) => {
            return deviceGroupDelete({
                url: `/device-groups/${deviceGroupTag}`,
                method: "DELETE",
                params,
                signal,
            });
        },
        [deviceGroupDelete],
    );
};

export const useDeviceGroupDeleteMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeviceGroupDeleteHook>>>,
        TError,
        { deviceGroupTag: string; params?: DeviceGroupDeleteParams },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeviceGroupDeleteHook>>>,
    TError,
    { deviceGroupTag: string; params?: DeviceGroupDeleteParams },
    TContext
> => {
    const mutationKey = ["deviceGroupDelete"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const deviceGroupDelete = useDeviceGroupDeleteHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useDeviceGroupDeleteHook>>>,
        { deviceGroupTag: string; params?: DeviceGroupDeleteParams }
    > = (props) => {
        const { deviceGroupTag, params } = props ?? {};

        return deviceGroupDelete(deviceGroupTag, params);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeviceGroupDeleteMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeviceGroupDeleteHook>>>
>;

export type DeviceGroupDeleteMutationError = ErrorType<unknown>;

export const useDeviceGroupDelete = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useDeviceGroupDeleteHook>>>,
            TError,
            { deviceGroupTag: string; params?: DeviceGroupDeleteParams },
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useDeviceGroupDeleteHook>>>,
    TError,
    { deviceGroupTag: string; params?: DeviceGroupDeleteParams },
    TContext
> => {
    return useMutation(
        useDeviceGroupDeleteMutationOptions(options),
        queryClient,
    );
};
/**
 * Insert/Update device group. Use null DeviceGroupTag when inserting. Does not update the user/device/rfidTag mappings.
 */
export const useDeviceGroupUpdateHook = () => {
    const deviceGroupUpdate = useCustomFetchClient<ApiResult>();

    return useCallback(
        (deviceGroupDto?: BodyType<DeviceGroupDto>, signal?: AbortSignal) => {
            return deviceGroupUpdate({
                url: `/device-groups`,
                method: "POST",
                headers: { "Content-Type": "application/json" },
                data: deviceGroupDto,
                signal,
            });
        },
        [deviceGroupUpdate],
    );
};

export const useDeviceGroupUpdateMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeviceGroupUpdateHook>>>,
        TError,
        { data?: BodyType<DeviceGroupDto> },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeviceGroupUpdateHook>>>,
    TError,
    { data?: BodyType<DeviceGroupDto> },
    TContext
> => {
    const mutationKey = ["deviceGroupUpdate"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const deviceGroupUpdate = useDeviceGroupUpdateHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useDeviceGroupUpdateHook>>>,
        { data?: BodyType<DeviceGroupDto> }
    > = (props) => {
        const { data } = props ?? {};

        return deviceGroupUpdate(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeviceGroupUpdateMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeviceGroupUpdateHook>>>
>;
export type DeviceGroupUpdateMutationBody =
    | BodyType<DeviceGroupDto>
    | undefined;
export type DeviceGroupUpdateMutationError = ErrorType<unknown>;

export const useDeviceGroupUpdate = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useDeviceGroupUpdateHook>>>,
            TError,
            { data?: BodyType<DeviceGroupDto> },
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useDeviceGroupUpdateHook>>>,
    TError,
    { data?: BodyType<DeviceGroupDto> },
    TContext
> => {
    return useMutation(
        useDeviceGroupUpdateMutationOptions(options),
        queryClient,
    );
};
/**
 * Add or remove devices from groups.
 */
export const useDeviceGroupMapDevicesHook = () => {
    const deviceGroupMapDevices = useCustomFetchClient<ApiMultipleResult>();

    return useCallback(
        (
            deviceGroupTag: string,
            deviceGroupMapDevicesRequest?: BodyType<DeviceGroupMapDevicesRequest>,
            signal?: AbortSignal,
        ) => {
            return deviceGroupMapDevices({
                url: `/device-groups/${deviceGroupTag}/devices`,
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                data: deviceGroupMapDevicesRequest,
                signal,
            });
        },
        [deviceGroupMapDevices],
    );
};

export const useDeviceGroupMapDevicesMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeviceGroupMapDevicesHook>>>,
        TError,
        {
            deviceGroupTag: string;
            data?: BodyType<DeviceGroupMapDevicesRequest>;
        },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeviceGroupMapDevicesHook>>>,
    TError,
    { deviceGroupTag: string; data?: BodyType<DeviceGroupMapDevicesRequest> },
    TContext
> => {
    const mutationKey = ["deviceGroupMapDevices"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const deviceGroupMapDevices = useDeviceGroupMapDevicesHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useDeviceGroupMapDevicesHook>>>,
        {
            deviceGroupTag: string;
            data?: BodyType<DeviceGroupMapDevicesRequest>;
        }
    > = (props) => {
        const { deviceGroupTag, data } = props ?? {};

        return deviceGroupMapDevices(deviceGroupTag, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeviceGroupMapDevicesMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeviceGroupMapDevicesHook>>>
>;
export type DeviceGroupMapDevicesMutationBody =
    | BodyType<DeviceGroupMapDevicesRequest>
    | undefined;
export type DeviceGroupMapDevicesMutationError = ErrorType<unknown>;

export const useDeviceGroupMapDevices = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<ReturnType<typeof useDeviceGroupMapDevicesHook>>
            >,
            TError,
            {
                deviceGroupTag: string;
                data?: BodyType<DeviceGroupMapDevicesRequest>;
            },
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useDeviceGroupMapDevicesHook>>>,
    TError,
    { deviceGroupTag: string; data?: BodyType<DeviceGroupMapDevicesRequest> },
    TContext
> => {
    return useMutation(
        useDeviceGroupMapDevicesMutationOptions(options),
        queryClient,
    );
};
/**
 * Add or remove user accounts from groups, for access control. Currently only EnterpriseUser and Driver account types may be mapped. See also: SetUserAccountDeviceGroups
 */
export const useDeviceGroupMapUserAccountsHook = () => {
    const deviceGroupMapUserAccounts =
        useCustomFetchClient<ApiMultipleResult>();

    return useCallback(
        (
            deviceGroupTag: string,
            deviceGroupMapUserAccountsRequest?: BodyType<DeviceGroupMapUserAccountsRequest>,
            signal?: AbortSignal,
        ) => {
            return deviceGroupMapUserAccounts({
                url: `/device-groups/${deviceGroupTag}/user-accounts`,
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                data: deviceGroupMapUserAccountsRequest,
                signal,
            });
        },
        [deviceGroupMapUserAccounts],
    );
};

export const useDeviceGroupMapUserAccountsMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof useDeviceGroupMapUserAccountsHook>>
        >,
        TError,
        {
            deviceGroupTag: string;
            data?: BodyType<DeviceGroupMapUserAccountsRequest>;
        },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeviceGroupMapUserAccountsHook>>>,
    TError,
    {
        deviceGroupTag: string;
        data?: BodyType<DeviceGroupMapUserAccountsRequest>;
    },
    TContext
> => {
    const mutationKey = ["deviceGroupMapUserAccounts"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const deviceGroupMapUserAccounts = useDeviceGroupMapUserAccountsHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<ReturnType<typeof useDeviceGroupMapUserAccountsHook>>
        >,
        {
            deviceGroupTag: string;
            data?: BodyType<DeviceGroupMapUserAccountsRequest>;
        }
    > = (props) => {
        const { deviceGroupTag, data } = props ?? {};

        return deviceGroupMapUserAccounts(deviceGroupTag, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeviceGroupMapUserAccountsMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeviceGroupMapUserAccountsHook>>>
>;
export type DeviceGroupMapUserAccountsMutationBody =
    | BodyType<DeviceGroupMapUserAccountsRequest>
    | undefined;
export type DeviceGroupMapUserAccountsMutationError = ErrorType<unknown>;

export const useDeviceGroupMapUserAccounts = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<ReturnType<typeof useDeviceGroupMapUserAccountsHook>>
            >,
            TError,
            {
                deviceGroupTag: string;
                data?: BodyType<DeviceGroupMapUserAccountsRequest>;
            },
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useDeviceGroupMapUserAccountsHook>>>,
    TError,
    {
        deviceGroupTag: string;
        data?: BodyType<DeviceGroupMapUserAccountsRequest>;
    },
    TContext
> => {
    return useMutation(
        useDeviceGroupMapUserAccountsMutationOptions(options),
        queryClient,
    );
};
/**
 * Add or remove RfidTags from groups. Only RfidTags with Rule=DeviceGroups may be mapped. See also: SetRfidTagDeviceGroups
 */
export const useDeviceGroupMapRfidTagsHook = () => {
    const deviceGroupMapRfidTags = useCustomFetchClient<ApiMultipleResult>();

    return useCallback(
        (
            deviceGroupTag: string,
            deviceGroupMapRfidTagsRequest?: BodyType<DeviceGroupMapRfidTagsRequest>,
            signal?: AbortSignal,
        ) => {
            return deviceGroupMapRfidTags({
                url: `/device-groups/${deviceGroupTag}/rfidtags`,
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                data: deviceGroupMapRfidTagsRequest,
                signal,
            });
        },
        [deviceGroupMapRfidTags],
    );
};

export const useDeviceGroupMapRfidTagsMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeviceGroupMapRfidTagsHook>>>,
        TError,
        {
            deviceGroupTag: string;
            data?: BodyType<DeviceGroupMapRfidTagsRequest>;
        },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeviceGroupMapRfidTagsHook>>>,
    TError,
    { deviceGroupTag: string; data?: BodyType<DeviceGroupMapRfidTagsRequest> },
    TContext
> => {
    const mutationKey = ["deviceGroupMapRfidTags"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const deviceGroupMapRfidTags = useDeviceGroupMapRfidTagsHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useDeviceGroupMapRfidTagsHook>>>,
        {
            deviceGroupTag: string;
            data?: BodyType<DeviceGroupMapRfidTagsRequest>;
        }
    > = (props) => {
        const { deviceGroupTag, data } = props ?? {};

        return deviceGroupMapRfidTags(deviceGroupTag, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeviceGroupMapRfidTagsMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeviceGroupMapRfidTagsHook>>>
>;
export type DeviceGroupMapRfidTagsMutationBody =
    | BodyType<DeviceGroupMapRfidTagsRequest>
    | undefined;
export type DeviceGroupMapRfidTagsMutationError = ErrorType<unknown>;

export const useDeviceGroupMapRfidTags = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<ReturnType<typeof useDeviceGroupMapRfidTagsHook>>
            >,
            TError,
            {
                deviceGroupTag: string;
                data?: BodyType<DeviceGroupMapRfidTagsRequest>;
            },
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useDeviceGroupMapRfidTagsHook>>>,
    TError,
    { deviceGroupTag: string; data?: BodyType<DeviceGroupMapRfidTagsRequest> },
    TContext
> => {
    return useMutation(
        useDeviceGroupMapRfidTagsMutationOptions(options),
        queryClient,
    );
};
/**
 * Get various uptime metrics for device groups with type of Site or Organisation (or ServiceModel). Will default to last 30 days if date range not specified.
 */
export const useDeviceGroupUptimeHook = () => {
    const deviceGroupUptime = useCustomFetchClient<DeviceGroupUptimeResponse>();

    return useCallback(
        (
            deviceGroupTag: string,
            params?: DeviceGroupUptimeParams,
            signal?: AbortSignal,
        ) => {
            return deviceGroupUptime({
                url: `/device-groups/${deviceGroupTag}/uptime`,
                method: "GET",
                params,
                signal,
            });
        },
        [deviceGroupUptime],
    );
};

export const getDeviceGroupUptimeQueryKey = (
    deviceGroupTag: string,
    params?: DeviceGroupUptimeParams,
) => {
    return [
        `/device-groups/${deviceGroupTag}/uptime`,
        ...(params ? [params] : []),
    ] as const;
};

export const useDeviceGroupUptimeQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceGroupUptimeHook>>>,
    TError = ErrorType<unknown>,
>(
    deviceGroupTag: string,
    params?: DeviceGroupUptimeParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useDeviceGroupUptimeHook>>
                >,
                TError,
                TData
            >
        >;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getDeviceGroupUptimeQueryKey(deviceGroupTag, params);

    const deviceGroupUptime = useDeviceGroupUptimeHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useDeviceGroupUptimeHook>>>
    > = ({ signal }) => deviceGroupUptime(deviceGroupTag, params, signal);

    return {
        queryKey,
        queryFn,
        enabled: !!deviceGroupTag,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDeviceGroupUptimeHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DeviceGroupUptimeQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeviceGroupUptimeHook>>>
>;
export type DeviceGroupUptimeQueryError = ErrorType<unknown>;

export function useDeviceGroupUptime<
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceGroupUptimeHook>>>,
    TError = ErrorType<unknown>,
>(
    deviceGroupTag: string,
    params: undefined | DeviceGroupUptimeParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useDeviceGroupUptimeHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<ReturnType<typeof useDeviceGroupUptimeHook>>
                    >,
                    TError,
                    Awaited<
                        ReturnType<ReturnType<typeof useDeviceGroupUptimeHook>>
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDeviceGroupUptime<
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceGroupUptimeHook>>>,
    TError = ErrorType<unknown>,
>(
    deviceGroupTag: string,
    params?: DeviceGroupUptimeParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useDeviceGroupUptimeHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<ReturnType<typeof useDeviceGroupUptimeHook>>
                    >,
                    TError,
                    Awaited<
                        ReturnType<ReturnType<typeof useDeviceGroupUptimeHook>>
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDeviceGroupUptime<
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceGroupUptimeHook>>>,
    TError = ErrorType<unknown>,
>(
    deviceGroupTag: string,
    params?: DeviceGroupUptimeParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useDeviceGroupUptimeHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useDeviceGroupUptime<
    TData = Awaited<ReturnType<ReturnType<typeof useDeviceGroupUptimeHook>>>,
    TError = ErrorType<unknown>,
>(
    deviceGroupTag: string,
    params?: DeviceGroupUptimeParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useDeviceGroupUptimeHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useDeviceGroupUptimeQueryOptions(
        deviceGroupTag,
        params,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Get various daily uptime metrics for device groups with type of Site or Organisation. Will default to last 30 days if date range not specified.
 */
export const useDeviceGroupDailyUptimesHook = () => {
    const deviceGroupDailyUptimes =
        useCustomFetchClient<DeviceGroupUptimeResponse[]>();

    return useCallback(
        (
            deviceGroupTag: string,
            params?: DeviceGroupDailyUptimesParams,
            signal?: AbortSignal,
        ) => {
            return deviceGroupDailyUptimes({
                url: `/device-groups/${deviceGroupTag}/uptime-daily`,
                method: "GET",
                params,
                signal,
            });
        },
        [deviceGroupDailyUptimes],
    );
};

export const getDeviceGroupDailyUptimesQueryKey = (
    deviceGroupTag: string,
    params?: DeviceGroupDailyUptimesParams,
) => {
    return [
        `/device-groups/${deviceGroupTag}/uptime-daily`,
        ...(params ? [params] : []),
    ] as const;
};

export const useDeviceGroupDailyUptimesQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useDeviceGroupDailyUptimesHook>>
    >,
    TError = ErrorType<unknown>,
>(
    deviceGroupTag: string,
    params?: DeviceGroupDailyUptimesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof useDeviceGroupDailyUptimesHook>
                    >
                >,
                TError,
                TData
            >
        >;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getDeviceGroupDailyUptimesQueryKey(deviceGroupTag, params);

    const deviceGroupDailyUptimes = useDeviceGroupDailyUptimesHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useDeviceGroupDailyUptimesHook>>>
    > = ({ signal }) => deviceGroupDailyUptimes(deviceGroupTag, params, signal);

    return {
        queryKey,
        queryFn,
        enabled: !!deviceGroupTag,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDeviceGroupDailyUptimesHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DeviceGroupDailyUptimesQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeviceGroupDailyUptimesHook>>>
>;
export type DeviceGroupDailyUptimesQueryError = ErrorType<unknown>;

export function useDeviceGroupDailyUptimes<
    TData = Awaited<
        ReturnType<ReturnType<typeof useDeviceGroupDailyUptimesHook>>
    >,
    TError = ErrorType<unknown>,
>(
    deviceGroupTag: string,
    params: undefined | DeviceGroupDailyUptimesParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof useDeviceGroupDailyUptimesHook>
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useDeviceGroupDailyUptimesHook>
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useDeviceGroupDailyUptimesHook>
                        >
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDeviceGroupDailyUptimes<
    TData = Awaited<
        ReturnType<ReturnType<typeof useDeviceGroupDailyUptimesHook>>
    >,
    TError = ErrorType<unknown>,
>(
    deviceGroupTag: string,
    params?: DeviceGroupDailyUptimesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof useDeviceGroupDailyUptimesHook>
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useDeviceGroupDailyUptimesHook>
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useDeviceGroupDailyUptimesHook>
                        >
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDeviceGroupDailyUptimes<
    TData = Awaited<
        ReturnType<ReturnType<typeof useDeviceGroupDailyUptimesHook>>
    >,
    TError = ErrorType<unknown>,
>(
    deviceGroupTag: string,
    params?: DeviceGroupDailyUptimesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof useDeviceGroupDailyUptimesHook>
                    >
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useDeviceGroupDailyUptimes<
    TData = Awaited<
        ReturnType<ReturnType<typeof useDeviceGroupDailyUptimesHook>>
    >,
    TError = ErrorType<unknown>,
>(
    deviceGroupTag: string,
    params?: DeviceGroupDailyUptimesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof useDeviceGroupDailyUptimesHook>
                    >
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useDeviceGroupDailyUptimesQueryOptions(
        deviceGroupTag,
        params,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Update device group contacts. The new contacts will replace the old contacts of the device group.
 */
export const useDeviceGroupContactUpdateHook = () => {
    const deviceGroupContactUpdate = useCustomFetchClient<ApiResult>();

    return useCallback(
        (
            deviceGroupTag: string,
            updateDeviceGroupContactsRequest?: BodyType<UpdateDeviceGroupContactsRequest>,
            signal?: AbortSignal,
        ) => {
            return deviceGroupContactUpdate({
                url: `/device-groups/${deviceGroupTag}/contacts`,
                method: "POST",
                headers: { "Content-Type": "application/json" },
                data: updateDeviceGroupContactsRequest,
                signal,
            });
        },
        [deviceGroupContactUpdate],
    );
};

export const useDeviceGroupContactUpdateMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeviceGroupContactUpdateHook>>>,
        TError,
        {
            deviceGroupTag: string;
            data?: BodyType<UpdateDeviceGroupContactsRequest>;
        },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeviceGroupContactUpdateHook>>>,
    TError,
    {
        deviceGroupTag: string;
        data?: BodyType<UpdateDeviceGroupContactsRequest>;
    },
    TContext
> => {
    const mutationKey = ["deviceGroupContactUpdate"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const deviceGroupContactUpdate = useDeviceGroupContactUpdateHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useDeviceGroupContactUpdateHook>>>,
        {
            deviceGroupTag: string;
            data?: BodyType<UpdateDeviceGroupContactsRequest>;
        }
    > = (props) => {
        const { deviceGroupTag, data } = props ?? {};

        return deviceGroupContactUpdate(deviceGroupTag, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeviceGroupContactUpdateMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeviceGroupContactUpdateHook>>>
>;
export type DeviceGroupContactUpdateMutationBody =
    | BodyType<UpdateDeviceGroupContactsRequest>
    | undefined;
export type DeviceGroupContactUpdateMutationError = ErrorType<unknown>;

export const useDeviceGroupContactUpdate = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<ReturnType<typeof useDeviceGroupContactUpdateHook>>
            >,
            TError,
            {
                deviceGroupTag: string;
                data?: BodyType<UpdateDeviceGroupContactsRequest>;
            },
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useDeviceGroupContactUpdateHook>>>,
    TError,
    {
        deviceGroupTag: string;
        data?: BodyType<UpdateDeviceGroupContactsRequest>;
    },
    TContext
> => {
    return useMutation(
        useDeviceGroupContactUpdateMutationOptions(options),
        queryClient,
    );
};
/**
 * Toggle favourite device group for the current IlluminateUser.
 */
export const useToggleFavouriteDeviceGroupHook = () => {
    const toggleFavouriteDeviceGroup = useCustomFetchClient<ApiResult>();

    return useCallback(
        (
            deviceGroupTag: string,
            params: ToggleFavouriteDeviceGroupParams,
            signal?: AbortSignal,
        ) => {
            return toggleFavouriteDeviceGroup({
                url: `/device-groups/${deviceGroupTag}/favourite`,
                method: "PATCH",
                params,
                signal,
            });
        },
        [toggleFavouriteDeviceGroup],
    );
};

export const useToggleFavouriteDeviceGroupMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof useToggleFavouriteDeviceGroupHook>>
        >,
        TError,
        { deviceGroupTag: string; params: ToggleFavouriteDeviceGroupParams },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useToggleFavouriteDeviceGroupHook>>>,
    TError,
    { deviceGroupTag: string; params: ToggleFavouriteDeviceGroupParams },
    TContext
> => {
    const mutationKey = ["toggleFavouriteDeviceGroup"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const toggleFavouriteDeviceGroup = useToggleFavouriteDeviceGroupHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<ReturnType<typeof useToggleFavouriteDeviceGroupHook>>
        >,
        { deviceGroupTag: string; params: ToggleFavouriteDeviceGroupParams }
    > = (props) => {
        const { deviceGroupTag, params } = props ?? {};

        return toggleFavouriteDeviceGroup(deviceGroupTag, params);
    };

    return { mutationFn, ...mutationOptions };
};

export type ToggleFavouriteDeviceGroupMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useToggleFavouriteDeviceGroupHook>>>
>;

export type ToggleFavouriteDeviceGroupMutationError = ErrorType<unknown>;

export const useToggleFavouriteDeviceGroup = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<ReturnType<typeof useToggleFavouriteDeviceGroupHook>>
            >,
            TError,
            {
                deviceGroupTag: string;
                params: ToggleFavouriteDeviceGroupParams;
            },
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useToggleFavouriteDeviceGroupHook>>>,
    TError,
    { deviceGroupTag: string; params: ToggleFavouriteDeviceGroupParams },
    TContext
> => {
    return useMutation(
        useToggleFavouriteDeviceGroupMutationOptions(options),
        queryClient,
    );
};
